import React from "react";
import { Container } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { UsersData } from "./UsersData";

const Users = () => {
  document.title = "Users | mrmto";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="mrmto" breadcrumbItem="Users" />
          <UsersData />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Users;
